export default "__VITE_ASSET__CEj9oEc1__ 720w";